
import React, { Component } from 'react';

import { connect } from 'react-redux';
import Logo from '../../assets/images/Logo.svg'

import Moment from 'react-moment';
import { date } from 'yup';



class GeneratedReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderList: null,
            itemList: null,
            restaurent_id: null,
            dashboardData: {},
            errors: {},
            serverError: {},
            isLoading: false,
            activeTab: 1,
            book_url: "",
            epub: "",
            original_book_name: "",
            reportContent: [],
            data: {},
            totalEarning: 0,
            totalPayment: 0,
            totalSale: 0,
            paymentList: [],

        };

    }

    componentDidUpdate(prevProps, prevState, snapshot) {


    }


    componentWillMount() {

        if (this.props?.location?.state?.content) {


            console.log(this.props.location.state.content)
            this.setState({
                reportContent: this.props.location.state.content

            })
        }

        if (this.props?.location?.state?.data) {


            //console.log(this.props.location.state.data)
            this.setState({
                data: this.props.location.state.data

            })
        }

    }
    componentDidMount() {

        console.log(this.props.user)
        this.getTotal()


    }



    printReceipt() {
        window.print();
    }


    sortByNewestData(a, b) {
        const date1 = new Date(a.createdAt)
        const date2 = new Date(b.createdAt)

        return date2 - date1
    }

    getTotal = () => {
        var totalEarning = 0
        var totalSale = 0
        var paymentList = this.state.paymentList
        var totalPayment = 0
        var list = [];
        var totalinPKR = 0
        var totalinUSD = 0
        var totalSaleinPKR = 0
        var totalSaleinUSD = 0


        console.log('PaymentList', this.state.reportContent)
        for (let i = 0; i < this.state.reportContent.length; i++) {
            let order_has_books = this.state.reportContent[i].order_has_books;
            let currency = this.state.reportContent[i].currency;
            let dollarRate = this.state.reportContent[i].dollarRate;
            // console.log(order_has_books);
            for (var j = 0; j < order_has_books.length; j++) {
                let newItem = order_has_books[j];
                newItem.currency = currency;
                newItem.dollarRate = dollarRate;
                // list.push(order_has_books[j])
                list.push(newItem)
            }
        }
        console.log('LIST TO CALCULATE', list)

        for (let start = 0; start < list.length; start++) {
            if (list[start].currency == 'PKR') {
                totalinPKR = totalinPKR + parseInt(list[start].bookAmount);
                totalSaleinPKR = totalSaleinPKR + parseInt(list[start].bookAmount - list[start].clearingAmount)
            }
            else {
                totalinUSD = totalinUSD + parseInt(list[start].bookAmount * list[start].dollarRate)
                totalSaleinUSD = totalSaleinUSD + parseInt((list[start].bookAmount * list[start].dollarRate) - (list[start].clearingAmount * list[start].dollarRate))
            }

            if (list[start].Status === 'Cleared') {
                paymentList.push(list[start])
                if(list[start].currency == 'PKR'){
                    totalPayment = totalPayment + parseInt(list[start]?.clearingAmount)
                }
                totalPayment = totalPayment + parseInt(list[start]?.clearingAmount * list[start].dollarRate)
            }
        }
        console.log('PKR Amount', totalinPKR)
        console.log('USD Amount', totalinUSD)
        console.log('PKR Sale', totalSaleinPKR)
        console.log('USD Sale', totalSaleinUSD)

        this.setState({ totalEarning: totalinPKR + totalinUSD, totalSale: totalSaleinPKR + totalSaleinUSD, paymentList: paymentList, totalPayment: totalPayment })
    }

    renderTableRows = () => {
        var myData = [];
        console.log('Report content', this.state.reportContent)
        return this.state.reportContent.sort(this.sortByNewestData).map((item, i) =>
            <>
                {item?.order_has_books?.length > 0 && item?.order_has_books.map((citem, index) =>
                    <tr>
                        <td><Moment format="DD-MM-YY">{item.createdAt}</Moment></td>
                        <td>{item?.Order_ID}</td>
                        <td>{citem.book?.Name}</td>
                        <td>
                            {
                                item?.currency == "PKR" ? (
                                    item?.order_has_books[0].bookAmount + ' PKR'
                                ) : (
                                    <span>
                                        {
                                            item?.order_has_books[0].bookAmount * item.dollarRate + ' PKR '
                                        }
                                        <span style={{ color: '#adb5bd' }}>
                                            {
                                                `(${`$` + item?.order_has_books[0].bookAmount} * ${item.dollarRate + ' CR'})`
                                            }
                                        </span>
                                    </span>
                                )
                            }
                        </td>
                        <td>{item?.Payment_Method}</td>
                        {/* <td>{item?.Payment_Method == "PayPal" ? (citem?.book?.Price_USD * 150) * 0.7 : citem?.book?.Price * 0.7}</td> */}
                        <td>
                            {
                                item.currency == 'PKR' ? (
                                    item.order_has_books[0].clearingAmount == null ? (
                                        0
                                    ) : (
                                        item.order_has_books[0].clearingAmount + 'PKR'
                                    )
                                ) : (
                                    item.order_has_books[0].clearingAmount * item?.dollarRate + ' PKR'
                                    // item.order_has_books[0].clearingAmount + ' PKR'
                                )
                            }
                        </td>
                        <td>
                            {
                                item.currency == 'PKR' ? (
                                    item?.order_has_books[0].bookAmount - item?.order_has_books[0].clearingAmount + ' PKR'
                                ) : (

                                    (item?.order_has_books[0].bookAmount * item?.dollarRate) - (item?.order_has_books[0].clearingAmount * item.dollarRate) + ' PKR'
                                )
                            }
                        </td>
                    </tr>
                )}
            </>
        )
    }



    renderPayement = () => {
        console.log('Render Payment List : ', this.state.paymentList)
        return this.state.paymentList.map((item, i) =>
            <>
                <tr>
                    <td scope="col table_header poppins_medium"> <p className="mb-0">{<Moment format="DD-MM-YY">{item.createdAt}</Moment>}</p> </td>
                    <td>{item?.Order_ID}</td>

                    <td scope="col table_header poppins_medium"> <p className="mb-0">{item.Reference_No}</p> </td>

                    <td scope="col table_header poppins_medium"> <p className="mb-0">{item?.book?.Author_Name}</p> </td>
                    <td scope="col table_header poppins_medium">
                        <p className="mb-0">
                        {   
                            item?.currency == 'USD'?(
                                item?.clearingAmount * item?.dollarRate
                            ):(
                                item?.clearingAmount
                            )
                        }
                        </p>
                    </td>
                </tr>
            </>
        )
    }

    render() {

        const { isLoading, totalEarning } = this.state;

        if (isLoading) {
            return (
                <div className="loader-large"></div>
            )
        }
        console.log(totalEarning)
        return (
            <div className="GeneratedReportContainer">
                <div className="text-right mt-4 mb-4">
                    <button className="hide-on-print" onClick={this.printReceipt}>Print</button>
                </div>
                <div className="col-12 ">
                    <div className="row">
                        <div className="col-2">
                            <img className="W_90" src={Logo} />
                            <div className="HorizontalLine"></div>

                        </div>

                        <div className="col-8">
                            <p className="poppins_regular mb-0 SaleReportHEading">Sales Report</p>
                            <p className="poppins_medium  mb-0 SaleReportHEading1">{this.state.reportContent[0]?.order_has_books[0]?.book?.publisher?.user?.Full_Name}</p>
                            <p className="poppins_regular mb-0 SaleReportHEading">From <Moment format="D MMMM YYYY">{this.state.data?.startDate}</Moment> till <Moment format="D MMMM YYYY">{this.state.data?.endDate}</Moment></p>

                        </div>
                    </div>
                </div>
                <div className="col-12 GenratedReportTable mt-5">
                    <table className="table table-hover thead-primary ">
                        <thead>
                            <tr>
                                <th scope="col table_header poppins_medium">Date </th>

                                <th scope="col table_header poppins_medium">Order ID  </th>
                                <th scope="col table_header poppins_medium">Book Name </th>
                                <th scope="col table_header poppins_medium">Book Price </th>

                                <th scope="col table_header poppins_medium">Payment Method </th>
                                <th scope="col table_header poppins_medium">Author's Earning</th>

                                <th scope="col table_header poppins_medium">
                                    <p className="mb-0">Total Sale</p>
                                    <p className="mb-0 ExcludingText">Excluding TLBC 30 %</p>
                                </th>


                            </tr>
                        </thead>
                        <tbody>
                            {this.state.reportContent && this.renderTableRows()}
                        </tbody>

                        <tfoot className="mt-5 Foot borderTp">
                            <tr>
                                <th scope="col table_header poppins_medium text-left" colspan="3"><p className="PaymentTransfer" style={{ textAlign: 'left', margin: '0px', fontWeight: '500', fontSize: '22px' }}>Total Sale </p></th>
                                {/* <th scope="col table_header poppins_medium" >{this.state.totalEarning} </th> */}
                                <th scope="col table_header poppins_medium" ></th>
                                <th></th>
                                <th></th>
                                <th scope="col table_header poppins_medium">
                                    <p className="mb-0 PaymentTransfer" style={{ textAlign: 'right' }}>
                                        {
                                            this.state.totalEarning + ' PKR'
                                        }
                                    </p>
                                </th>


                            </tr>
                            <tr>
                                <th scope="col table_header poppins_medium text-left" colspan="3">
                                    <p className="PaymentTransfer" style={{ textAlign: 'left', margin: '0px', fontWeight: '500', fontSize: '22px' }}>
                                        Total Sale <span style={{ color: '#adb5bd' }}>Excluding TLBC 30 %</span>
                                    </p>
                                </th>
                                {/* <th scope="col table_header poppins_medium" >{this.state.totalEarning} </th> */}
                                <th scope="col table_header poppins_medium" ></th>
                                <th></th>
                                <th></th>
                                <th scope="col table_header poppins_medium">
                                    <p className="mb-0 PaymentTransfer" style={{ textAlign: 'right' }}>
                                        - {
                                            this.state.totalSale + ' PKR'
                                        }
                                    </p>
                                </th>
                            </tr>
                            <tr>
                                <th scope="col table_header poppins_medium text-left" colspan="3">
                                    <p className="PaymentTransfer" style={{ textAlign: 'left', margin: '0px', fontWeight: '500', fontSize: '22px' }}>
                                        Author Earning
                                    </p>
                                </th>
                                {/* <th scope="col table_header poppins_medium" >{this.state.totalEarning} </th> */}
                                <th scope="col table_header poppins_medium" ></th>
                                <th></th>
                                <th></th>
                                <th scope="col table_header poppins_medium">
                                    <p className="mb-0 PaymentTransfer" style={{ textAlign: 'right' }}>
                                        {
                                            this.state.totalEarning - this.state.totalSale + ' PKR'
                                        }
                                    </p>
                                </th>
                            </tr>
                        </tfoot>

                    </table>

                </div>

                <div className="col-12 GenratedReportTable2 mt-5">
                    <p className="PaymentTransfer">Payment Transfer</p>
                    <table className="table table-hover thead-primary ">
                        <thead>
                            <tr>


                                <th scope="col table_header poppins_medium"><p className="mb-0">Date</p>  </th>
                                <th scope="col table_header poppins_medium"><p className="mb-0">Order ID</p>  </th>

                                <th scope="col table_header poppins_medium"><p className="mb-0">Reference No. </p>  </th>

                                <th scope="col table_header poppins_medium"><p className="mb-0">Author Title</p> </th>
                                <th scope="col table_header poppins_medium"><p className="mb-0">Amount</p>  </th>




                            </tr>
                        </thead>

                        <tbody>




                            {this.renderPayement()}

                            <tr>
                                <td scope="col table_header poppins_medium text-left" colspan="3"><p className="GenratedReportTotalEaring">Total </p></td>

                                <td></td>
                                <td>{this.state.totalPayment}</td>


                            </tr>
                            <tr>
                                <td scope="col table_header poppins_medium text-left" colspan="3"><p className="GenratedReportTotalEaring">Balance </p></td>

                                <td></td>
                                <td>{(this.state.totalEarning - this.state.totalSale) - this.state.totalPayment} </td>
                                {/* <td>{(this.state.totalEarning * 0.7) - this.state.totalPayment} </td> */}


                            </tr>




                        </tbody>


                    </table>

                </div>

                {/* {this.renderPayement()} */}

                <div className="mt-5 col-12 text-center">
                    <p className="PageNAv">Page 1 /1</p>
                    <div className="HR"></div>
                    <p className="PageNAv">w w w. l i t t l e b o o kc o m pa n y. n e t</p>

                </div>
            </div>

        )
    }

}

GeneratedReport.propTypes = {

};


const mapStateToProps = state => ({
    auth: state.auth,
    user: state.auth.user
});

const mapDispatchToProps = ({

})
export default connect(mapStateToProps, mapDispatchToProps)(GeneratedReport);
